<template>

    <div class="pesticide-detection-wrap">

        <!-- 密码遮罩层：只盖住右侧内容，不遮挡左侧导航 -->
        <div class="pwd-mask" v-if="!hasAuth">
            <div class="pwd-box">
                <h3>请输入访问密码</h3>
                <el-input v-model="inputPwd" placeholder="请输入密码" show-password @keyup.enter="checkPwd"></el-input>
                <el-button type="primary" @click="checkPwd">确认</el-button>
            </div>
        </div>

        <div class="pesticide-detection" v-else>
            <!-- 搜索筛选区域 -->
            <el-card class="search-card">
                <el-form :inline="true" :model="searchForm" class="search-form">
                    <el-form-item label="项目名称">
                        <el-input v-model="searchForm.productName" placeholder="请输入项目名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleSearch">查询</el-button>
                        <el-button @click="resetSearch">重置</el-button>
                        <!-- 点击打开上传弹窗 -->
                        <el-button type="primary" @click="openUploadDialog">上传文件</el-button>
                    </el-form-item>
                </el-form>
            </el-card>

            <!-- 检测列表 -->
            <el-card class="table-card">
                <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                    <el-table-column prop="productName" label="项目名称" align="center"></el-table-column>
                    <el-table-column prop="type" label="文件类型" align="center"></el-table-column>
                    <el-table-column prop="code" label="code编码" align="center"></el-table-column>
                    <el-table-column prop="name" label="文件名称" align="center"></el-table-column>
                    <el-table-column prop="url" label="地址" align="center"></el-table-column>
                    <!-- 新增下载列 -->
                    <el-table-column label="操作" width="100" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-download" class="download-btn"
                                @click="downloadApk(scope.row)" :disabled="!scope.row.url">
                                下载
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 分页 -->
                <div class="pagination-container">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 50]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                    </el-pagination>
                </div>
            </el-card>

            <!-- 文件上传弹窗（修改提示文字：不限制大小） -->
            <el-dialog title="文件上传" :visible.sync="uploadDialogVisible" width="500px" :close-on-click-modal="false"
                @close="clearUploadData" :z-index="2000" append-to-body modal-append-to-body>
                <el-form :model="uploadForm" label-width="100px" class="upload-form">
                    <el-form-item label="项目名称">
                        <el-input v-model="uploadForm.productName" placeholder="请输入项目名称"></el-input>
                    </el-form-item>
                    <el-form-item label="code编码">
                        <el-input v-model="uploadForm.code" placeholder="code编码"></el-input>
                    </el-form-item>
                    <el-form-item label="文件名称">
                        <el-input v-model="uploadForm.name" disabled placeholder="选择文件后自动填充"></el-input>
                    </el-form-item>
                    <el-form-item label="文件后缀">
                        <el-input v-model="uploadForm.type" disabled placeholder="选择文件后自动填充"></el-input>
                    </el-form-item>
                    <el-form-item label="选择文件">
                        <!-- accept保持不变，tip文案修改 -->
                        <el-upload class="upload-file" action="#" :auto-upload="false" :file-list="uploadFileList"
                            :on-change="handleFileChange" :on-remove="handleFileRemove" accept=".apk,.jpg,.png,.jpeg"
                            :limit="1" :disabled="uploadLoading">
                            <el-button size="small" type="primary">选择文件</el-button>
                            <div slot="tip" class="el-upload__tip">支持APK、JPG、PNG格式文件，文件大小不限制</div>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="uploadDialogVisible = false" :disabled="uploadLoading">取消</el-button>
                    <el-button type="primary" @click="submitApkUpload" :disabled="!uploadFile || uploadLoading">
                        <i class="el-icon-loading" v-if="uploadLoading"></i>
                        {{ uploadLoading ? '上传中...' : '确认上传' }}
                    </el-button>
                </div>
            </el-dialog>
        </div>

    </div>
</template>

<script>
// 引入项目封装的上传接口
import { uploadApk, getApkList } from "@/api/files";
import { Message } from 'element-ui';

export default {
    data() {
        return {
            // 密码相关
            hasAuth: false,
            inputPwd: '',
            pwd: '6344',
            // 搜索表单：只保留项目名称用于查询
            searchForm: {
                productName: '',
            },
            // 表格数据
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            selectedRows: [],
            // 弹窗控制
            uploadDialogVisible: false, // 文件上传弹窗
            uploadLoading: false, // 上传加载状态
            // 上传相关数据
            uploadForm: {
                productName: '', // 项目名称
                code: '',        // code编码
                name: '', // 文件名称
                type: ''  // 文件后缀
            },
            uploadFileList: [], // 上传文件列表
            uploadFile: null,   // 选中的文件对象,
            // 文件类型配置：只保留类型校验，移除大小限制
            fileConfig: {
                apk: { typeDesc: 'APK安装包' },
                jpg: { typeDesc: '图片文件' },
                png: { typeDesc: '图片文件' },
                jpeg: { typeDesc: '图片文件' }
            }
        }
    },
    mounted() {
        // 读取本地存储，判断是否已经授权
        const auth = localStorage.getItem('filePageAuth');
        if (auth === 'true') {
            this.hasAuth = true;
            this.loadTableData();
        }
    },
    methods: {
        // 密码校验
        checkPwd() {
            if (this.inputPwd === this.pwd) {
                this.hasAuth = true;
                localStorage.setItem('filePageAuth', 'true');
                Message.success('验证成功');
                this.loadTableData();
            } else {
                Message.error('密码错误');
                this.inputPwd = '';
            }
        },

        // 加载表格分页列表
        async loadTableData() {
            try {
                const res = await getApkList({
                    pageNum: this.currentPage,
                    pageSize: this.pageSize,
                    ...this.searchForm
                });
                if (res.code === 200) {
                    // 如果后端分页返回结构是 {records:[], total:xxx} 就用下面这行
                    // this.tableData = res.data.records || [];
                    // this.totalCount = res.data.total || 0;
                    // 如果后端直接返回数组，用这行（根据你后端返回自行切换）
                    this.tableData = res.data || [];
                    this.totalCount = res.data.length || 0;
                } else {
                    this.tableData = [];
                    this.totalCount = 0;
                }
            } catch (err) {
                console.error('获取列表失败', err);
                this.tableData = [];
                this.totalCount = 0;
            }
        },

        // 搜索
        handleSearch() {
            this.currentPage = 1;
            this.loadTableData();
        },

        // 重置搜索
        resetSearch() {
            this.searchForm.productName = '';
            this.currentPage = 1;
            this.loadTableData();
        },

        // 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.loadTableData();
        },

        // 页码改变
        handleCurrentChange(val) {
            this.currentPage = val;
            this.loadTableData();
        },

        // 选择行变化
        handleSelectionChange(rows) {
            this.selectedRows = rows;
        },

        // 打开上传弹窗
        openUploadDialog() {
            this.uploadDialogVisible = true;
            // 清空上次上传数据
            this.clearUploadData();
        },

        // 清空上传数据
        clearUploadData() {
            this.uploadForm = {
                productName: '',
                code: '',
                name: '',
                type: ''
            };
            this.uploadFileList = [];
            this.uploadFile = null;
            this.uploadLoading = false;
        },

        // 文件选择变化事件：只校验后缀类型，**删除所有大小判断**
        handleFileChange(file, fileList) {
            // 获取文件后缀
            const fileSuffix = this.getFileSuffix(file.name).toLowerCase();
            // 检查文件类型是否支持
            if (!this.fileConfig[fileSuffix]) {
                Message.error(`不支持上传${fileSuffix}格式文件！仅支持APK、JPG、PNG、JPEG格式`);
                this.uploadFileList = [];
                return;
            }
            const typeDesc = this.fileConfig[fileSuffix].typeDesc;

            // 验证文件MIME类型（增强验证）
            const mimeTypes = {
                apk: 'application/vnd.android.package-archive',
                jpg: 'image/jpeg',
                jpeg: 'image/jpeg',
                png: 'image/png'
            };
            if (file.raw.type && !file.raw.type.includes(mimeTypes[fileSuffix]) && !file.name.endsWith(`.${fileSuffix}`)) {
                Message.error(`文件类型验证失败，请选择正确的${typeDesc}！`);
                this.uploadFileList = [];
                return;
            }

            this.uploadFileList = fileList.slice(-1); // 只保留最后一个文件
            this.uploadFile = file.raw; // 保存原始文件对象
            // 自动填充文件名称和后缀到表单
            this.uploadForm.name = file.name;
            this.uploadForm.type = fileSuffix;
        },

        // 移除上传文件
        handleFileRemove() {
            this.clearUploadData();
        },

        // 获取文件后缀
        getFileSuffix(fileName) {
            if (!fileName) return '';
            const lastDotIndex = fileName.lastIndexOf('.');
            return lastDotIndex > -1 ? fileName.slice(lastDotIndex + 1).toLowerCase() : '';
        },

        // 提交文件上传
        async submitApkUpload() {
            if (!this.uploadFile) {
                Message.warning('请先选择要上传的文件！');
                return;
            }
            if (!this.uploadForm.productName) {
                Message.warning('请输入项目名称');
                return;
            }
            if (!this.uploadForm.code) {
                Message.warning('请输入code编码');
                return;
            }
            try {
                this.uploadLoading = true;
                // 构造FormData，把项目名称、code一起传给后端
                const formData = new FormData();
                formData.append('productName', this.uploadForm.productName);
                formData.append('code', this.uploadForm.code);
                formData.append('name', this.uploadForm.name); // 文件名称
                formData.append('type', this.uploadForm.type); // 文件后缀
                formData.append('file', this.uploadFile);     // 文件对象
                formData.append('userId', localStorage.getItem('userId'));
                // 调用项目封装的接口
                const response = await uploadApk(formData);
                // 上传成功处理
                if (response.code === 200 || response.success) {
                    Message.success('文件上传成功！');
                    this.uploadDialogVisible = false; // 关闭弹窗
                    this.clearUploadData(); // 清空上传数据
                    this.loadTableData(); // 重新加载表格数据
                } else {
                    Message.error(`上传失败：${response.message || '服务器错误'}`);
                }
            } catch (error) {
                console.error('文件上传失败：', error);
                // 捕获413请求体过大，单独提示
                if (error.response && error.response.status === 413) {
                    Message.error('上传失败！网关/服务器限制了请求大小，请联系后端修改Nginx或服务配置');
                } else {
                    Message.error('文件上传失败，请重试！');
                }
            } finally {
                this.uploadLoading = false;
            }
        },

        /**
         * 下载文件
         * @param {Object} row 表格行数据
         */
        downloadApk(row) {
            // 校验下载地址是否存在
            if (!row.url) {
                Message.warning('该文件暂无下载地址！');
                return;
            }
            try {
                // 方案1：直接通过a标签下载（适用于公开可访问的URL）
                const link = document.createElement('a');
                link.href = row.url;
                // 设置下载文件名
                const fileName = row.name || `${row.productName}.${row.type}`;
                link.download = fileName;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                Message.success(`开始下载${row.type.toUpperCase()}文件！`);
            } catch (error) {
                console.error('文件下载失败：', error);
                Message.error('文件下载失败，请重试！');
                // 备选方案：如果直接下载失败，打开新窗口访问下载地址
                window.open(row.url, '_blank');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.pesticide-detection-wrap {
    position: relative;
    width: 100%;
    min-height: 100vh;
}

.pwd-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;

    .pwd-box {
        width: 360px;
        background: #fff;
        padding: 30px;
        border-radius: 8px;

        h3 {
            text-align: center;
            margin: 0 0 20px;
        }

        .el-input {
            margin-bottom: 20px;
        }

        .el-button {
            width: 100%;
        }
    }
}

.pesticide-detection {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

.search-card {
    margin-bottom: 20px;
}

.search-form {
    margin-top: 10px;
}

.table-card {
    .pagination-container {
        margin-top: 15px;
        text-align: right;
    }

    // 下载按钮样式
    .download-btn {
        color: #409eff;

        &:hover {
            color: #66b1ff;
        }

        &[disabled] {
            color: #c0c4cc;
            cursor: not-allowed;
        }
    }
}

// 上传弹窗样式
.upload-form {
    margin-top: 10px;

    .upload-file {
        margin-bottom: 0;
    }
}

.dialog-footer {
    text-align: right;
}

::v-deep .el-upload__tip {
    color: #999;
    font-size: 12px;
    margin-top: 5px;
}

::v-deep .el-dialog__body {
    padding-bottom: 0 !important;
}
</style>
